<ion-grid class="max-height p0">
  <ion-row class="mb">
    <ion-col size="7" sizeMd="12" class="full-height p0">
      @if (getLocalized(news_data.link)) {
        <iframe
          [class]="relatedNews ? 'full-height medium-data' : 'medium-data'"
          [src]="getLocalized(news_data.link) | safe"
          allowfullscreen
          class="border r-16"
          [class.fill_width]="fill_width"
          [title]="'Noticia ' + getLocalized(news_data.title)">
        </iframe>
      } @else if (getLocalized(news_data.video) || news_data.internVideo) {
        <div>
          <div>
            <video
              #videoPlayer
              class="border r-16"
              [class]="relatedNews ? 'full-height medium-data' : 'medium-data'"
              [src]="getLocalized(news_data.video) || news_data.internVideo"
              [poster]="isIphone && news_data.internVideo.includes('video_caminhos') ? 'assets/images/ricardo.jpg' : ''"
              [class.fill_width]="fill_width"
              (click)="$event.stopPropagation()"
              controls
              controlsList="nodownload">
              Seu navegador não suporta o elemento de vídeo.
            </video>
          </div>
        </div>
      } @else {
        <img
          class="medium-data border r-16"
          [src]="getLocalized(news_data.image) || 'assets/images/grupo-jacto.svg'"
          [class.fill_width]="fill_width"
          [alt]="'Noticia: ' + getLocalized(news_data.title)"
          aria-hidden="true" />
      }
    </ion-col>

    <ion-col size="5" sizeMd="12" class="lov v-center title">
      <div>
        <h1 class="text-overflow-prevent fs bold wrap min">{{ getLocalized(news_data.title) }}</h1>

        <div class="date-card">
          <span *ngIf="!news_data.startPostDate">{{ news_data.creationDate | date: 'dd/MM/yyyy' }}</span>
          <span *ngIf="news_data.startPostDate">{{ news_data.startPostDate | date: 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
